import React, { useState } from "react";
import {
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../config";
import { Button } from "../ui/button";
import { ResponsiveDrawerForm } from "../ResponsiveDrawerForm";
import BootstrapTable from "react-bootstrap-table-next";
import { CardTitle } from "../ui/card";
import CustomTooltip from "../CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { Badge } from "../ui/badge";
import { InfoCircledIcon } from "@radix-ui/react-icons";

const AdverseMedia = ({ adverse_media_result, reference_no }) => {
  const [show, setShow] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedEntity, setSelectedEntity] = useState();
  const toggleShowModal = () => {
    setShow(!show);
  };

  const entities =
    adverse_media_result?.length > 0
      ? adverse_media_result?.flatMap((result) =>
          (result?.entities || []).map((entity) => ({
            ...entity,
            list_code: (
              <div className="text-center">
                <Badge
                  variant="outline"
                  className={
                    result?.type === "sanction"
                      ? "border-transparent bg-webPrimary text-webPrimary-foreground shadow hover:bg-primary/80"
                      : "border-transparent bg-webSecondary text-webPrimary-foreground shadow hover:bg-primary/80"
                  }
                >
                  {result?.type ? result?.type.toUpperCase() : ""}
                </Badge>
              </div>
            ),
            search_result_name: result.search_result_name,
            match_on: result.match_on,
            match_type: result.match_type,
            stop_descriptor: result.stop_descriptor,
            is_hit: result.is_hit,
            total_matches: result.total_matches,
          })),
        )
      : [];

  const columns = [
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "id",
      text: "Entity Id",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "list_code",
      text: "List Code",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "name",
      text: "Name",
    },
    {
      headerClasses: THClasses,
      classes: `${TDClasses} whitespace-normal text-wrap`,
      dataField: "title",
      text: "Title",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "action",
      text: "Action",
    },
  ];

  const entityDataGenerator = (entities = []) => {
    return entities.map((entity) => ({
      key: entity.id,

      id: entity.id,

      list_code: entity.list_code,

      name: entity.name,

      title: entity.title,

      action: (
        <Button
          size="sm"
          onClick={() => {
            setSelectedEntity(entity);
            setShowDetails(true);
          }}
        >
          View
        </Button>
      ),
    }));
  };

  const data = entityDataGenerator(entities);
  return (
    <div className="flex items-center gap-2 justify-center">
      {entities?.length > 0 ? (
        <>
          <CustomTooltip message={"View"}>
            <span>
              <FontAwesomeIcon
                onClick={toggleShowModal}
                icon={faEye}
                size="1x"
              />
            </span>
          </CustomTooltip>
          <span>/</span>
        </>
      ) : (
        <></>
      )}
      {reference_no ? (
        <CustomTooltip message={`Reference: ${reference_no}`}>
          <InfoCircledIcon className="text-webPrimary" />
        </CustomTooltip>
      ) : (
        <></>
      )}
      <ResponsiveDrawerForm
        description={""}
        title={"Adverse Media"}
        handleOpen={() => {}}
        handleClose={() => {
          setShow(false);
        }}
        pop
        className={"md:w-[90vw]"}
        open={show}
        buttonClassName={""}
        setOpen={setShow}
        read={true}
      >
        <div className="custom-table">
          <div className={"table-body-class w-full"}>
            <BootstrapTable
              keyField="key"
              data={data}
              columns={columns}
              noDataIndication="No Data Found"
              rowClasses={TRClasses}
              classes={TableClasses}
              wrapperClasses={TableWrapClasses}
            />
          </div>
        </div>
      </ResponsiveDrawerForm>

      <ResponsiveDrawerForm
        description=""
        title="Accuity Match Details"
        handleOpen={() => {}}
        handleClose={() => {
          setShowDetails(false);
          setSelectedEntity({});
        }}
        className={"md:w-[65vw]"}
        open={showDetails}
        buttonClassName=""
        setOpen={setShowDetails}
        read={true}
      >
        <div className="md:p-0 p-4">
          <div className="modal-content">
            <CardTitle className="text-md mb-2">Entity Details</CardTitle>

            <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
              <p>
                <strong>Entity ID:</strong> {selectedEntity?.id || "-"}
              </p>

              <p>
                <strong>Name:</strong> {selectedEntity?.name || "-"}
              </p>

              <p>
                <strong>Title:</strong> {selectedEntity?.title || "-"}
              </p>

              <p>
                <strong>Source:</strong> {selectedEntity?.source || "-"}
              </p>

              <p>
                <strong>List Code:</strong> {selectedEntity?.list_code || "-"}
              </p>

              <p>
                <strong>Entity Type:</strong>{" "}
                {selectedEntity?.entity_type || "-"}
              </p>

              <p>
                <strong>Created Date:</strong>{" "}
                {selectedEntity?.created_date || "-"}
              </p>

              <p>
                <strong>Last Updated:</strong>{" "}
                {selectedEntity?.last_update_date || "-"}
              </p>

              <p>
                <strong>Country:</strong> {selectedEntity?.country || "-"}
              </p>

              <p>
                <strong>Country Name:</strong>{" "}
                {selectedEntity?.country_name || "-"}
              </p>

              <p>
                <strong>Gender:</strong> {selectedEntity?.gender || "-"}
              </p>

              <p>
                <strong>Entity Level:</strong>{" "}
                {selectedEntity?.entity_level || "-"}
              </p>

              <p>
                <strong>Sub Category:</strong>{" "}
                {selectedEntity?.sub_category || "-"}
              </p>

              <p>
                <strong>Name Source:</strong>{" "}
                {selectedEntity?.name_source || "-"}
              </p>

              <p>
                <strong>Original ID:</strong>{" "}
                {selectedEntity?.original_id || "-"}
              </p>

              <p>
                <strong>Version:</strong> {selectedEntity?.version || "-"}
              </p>

              <p>
                <strong>Effective Date:</strong>{" "}
                {selectedEntity?.effective_date || "-"}
              </p>

              <p>
                <strong>Expiration Date:</strong>{" "}
                {selectedEntity?.expiration_date || "-"}
              </p>

              <p className="md:col-span-2">
                <strong>Other Information:</strong>{" "}
                {selectedEntity?.other_information || "-"}
              </p>

              <p className="md:col-span-2 break-all">
                <strong>Direct ID:</strong> {selectedEntity?.direct_id || "-"}
              </p>
            </div>
          </div>
        </div>
      </ResponsiveDrawerForm>
    </div>
  );
};

export default AdverseMedia;
